import * as React from "react"
import { Row, Col } from "reactstrap"
import {
	ShopResult,
	ShopFilter,
	Pagination,
	Card,
	Seo,
	FloatingButton,
} from "components"
import { AfterPage } from "types/afterjs"
import fetchShop from "./actions"
import { Developer, ShopItem } from "types/shop"
import { ReactComponent as Filter } from "media/svg/filter.svg"

import { a } from "react-spring"
import { useShopFilter } from "hooks"

import "./shopPage.scss"

export interface ShopPage {
	developers: Developer[]
	items: ShopItem[]
	isPhoneSized: boolean
}

interface MatchProps {
	page?: string
	filter?: string
}

function initlizeFilters(developers?: Developer[], filter?: string) {
	if (developers && filter) {
		const item = developers.find(
			(item) => item.name.toLowerCase() === filter.toLowerCase()
		)
		return item ? [item.id] : []
	}

	return []
}

const itemsPerPage = 12

const height = 420

const ShopPage: AfterPage<ShopPage, MatchProps> = ({
	developers,
	items,
	isPhoneSized,
	match: {
		params: { filter, page },
	},
	location,
}) => {
	const getPageFromUrl = () => parseInt(page || "1", 10)
	const getFiltersFromUrl = () => initlizeFilters(developers, filter)

	const [currentPage, setCurrentPage] = React.useState(getPageFromUrl)
	const [filters, setProductFilters] = React.useState(getFiltersFromUrl)
	const [showOnlyAvailable, setShowOnlyAvailable] = React.useState(false)

	React.useEffect(() => {
		setProductFilters(initlizeFilters(developers, filter))
	}, [developers, filter])

	function setFilters(value: React.SetStateAction<number[]>) {
		setCurrentPage(1)
		setProductFilters(value)
	}

	const productItems =
		filters.length === 0
			? items
			: items.filter((item) => filters.includes(item.developer))

	const filtredProductItems = showOnlyAvailable
		? productItems.filter((product) => product.status === 1)
		: productItems

	const { bgStyle, sheetRef, bind, display, y, open } = useShopFilter(height)

	return (
		<>
			<Seo
				title="فروشگاه"
				description="فروشگاه مرجع آنتی ویروس  ایران معرفی و ارائه انواع آنتی ویروس در ایران، راه ها و روش های جلوگیری از ویروس های باجگیر و فروش نسخه سازمانی (تحت شبکه)"
				path="/shop"
			/>

			<Row>
				{!isPhoneSized && (
					<Col lg={3}>
						<ShopFilter
							key={location.pathname}
							filter={filter}
							developers={developers}
							setFilters={setFilters}
							setShowOnlyAvailable={setShowOnlyAvailable}
						/>
					</Col>
				)}
				<Col lg={9}>
					<a.div style={bgStyle}>
						<Card title="فروشگاه" className="shop">
							<ShopResult
								items={filtredProductItems.slice(
									(currentPage - 1) * itemsPerPage,
									(currentPage - 1) * itemsPerPage +
										itemsPerPage
								)}
							/>
							<Pagination
								className="d-flex justify-content-center align-items-center flex-row"
								totalItems={filtredProductItems.length}
								perPage={itemsPerPage}
								currentPage={currentPage}
								link="/shop"
								onClick={(page) => {
									setCurrentPage(page)
									const container = document.getElementsByClassName(
										"shop"
									)[0]!
									container.scrollIntoView({
										behavior: "smooth",
										block: "start",
									})
								}}
							/>
						</Card>
					</a.div>
				</Col>
				{isPhoneSized && (
					<>
						<a.div
							className="filter-sheet"
							ref={sheetRef}
							{...bind()}
							style={{
								display,
								bottom: `calc(-100vh + ${height - 100}px)`,
								y,
							}}
						>
							<ShopFilter
								key={location.pathname}
								filter={filter}
								developers={developers}
								setFilters={setFilters}
								setShowOnlyAvailable={setShowOnlyAvailable}
							/>
						</a.div>
						<FloatingButton
							color="accent"
							className="d-inline-block d-lg-none"
							onClick={() => open()}
						>
							<Filter fill="#fff" className="ml-1" />
							جستجوی پیشرفته
						</FloatingButton>
					</>
				)}
			</Row>
		</>
	)
}

ShopPage.getInitialProps = async ({ isPhoneSized }) => {
	try {
		const { data } = await fetchShop()
		return {
			developers: data.developers,
			items: data.items,
			isPhoneSized,
		}
	} catch (error) {
		return { error, isPhoneSized }
	}
}

export default ShopPage
